module.exports = __webpack_public_path__ + "img/icu.39210b17.svg";